import { Injectable } from '@angular/core';
import { VersetDuJourTextField } from '@core/models/bible/verset-du-jour-model';
import { ApiService } from '@core/service/api/api.service';
import { AuthorizationService } from '@core/service/authorization/authorization.service';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { ApiUrl } from '@shared/tools/constants/api.endpoints';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersetDuJourService extends UnsubscribeOnDestroyAdapter {

  endpoint: string = ApiUrl.VersetDuJourV1;
  public textField=VersetDuJourTextField;
  //public loadingDeviceAppVersionDataList=false;
  //public albumGroupeDataList: AlbumGroupeModel[]  = [];

  constructor( private apiService: ApiService, public authorizationService: AuthorizationService,) {super();}

  // getAll(data?: any) : Observable<any>{
  //   return this.apiService.getData(`${this.endpoint}`, data );
  // }
  getAllPaginate( data?: any) : Observable<any>{
    return this.apiService.getData(`${this.endpoint}/paginate`, data );
  }

  getOne( id: string ) : Observable<any> {
    return this.apiService.getData(`${this.endpoint}/${id}` );
  }

  insert( data: any ) : Observable<any>{
    return this.apiService.postData(`${this.endpoint}`, data, );
  }

  update(  data: any ) : Observable<any>{
    return this.apiService.putData(`${this.endpoint}`, data, );
  }
  saves( isNew: boolean, data: any ) : Observable<any>{
    if( isNew ){
      return this.insert(data);
    }
    return this.update(data);
  }

  delete( id: string ) : Observable<any>{
    return this.apiService.deleteData(`${this.endpoint}/${id}` );
  }
}
